module.exports = __webpack_public_path__ + "src/assets/img/GoldenSpaceFinance.90082402.png";